<template>
    <router-link :to="{ name: (getEnv === 'production' ? 'coming-soon-qualify' : 'home')}" class="qualify-push" :class="brandBackgroundColor">
    <!--<router-link :to="{ name: 'home'}" class="qualify-push" :class="brandBackgroundColor">-->
        <div class="icon-target"></div>
        <div class="title">
            {{ $t("i_qualify") }}
        </div>
        <p class="subtitle">
            {{ $t("find_the_most_fitted_solution") }}
        </p>
    </router-link>
</template>

<script>
    export default {
        name: 'QualifyPush'
    }
</script>

<style lang="scss">
    .qualify-push {
        position: relative;
        display: block;
        width: 200px;
        height: 260px;
        padding: 0 25px;
        text-align: center;
        border-radius: 20px;
        box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);

        @media #{$mq_tablet} {
            height: 225px;
        }

        @media #{$mq_phone} {
            height: 180px;
        }

        &:hover {
            background-color: $blackish;
        }

        &:after {
            @include icomoon;
            content: '\e90e';
            position: absolute;
            bottom: 36px;
            left: 0;
            right: 0;
            font-size: 20px;
            color: $white;

            @media #{$mq_tablet} {
                bottom: 30px;
            }

            @media #{$mq_phone} {
                display: none;
                bottom: 25px;
            }
        }

        [class^="icon-"], [class*=" icon-"] {
            font-size: 29px;
            margin-top: 38px;
            color: $white;

            @media #{$mq_phone} {
                margin-top: 25px;
            }
        }

        .title {
            margin-top: 15px;
            @include medium-title($white);
        }

        .subtitle {
            margin-top: 15px;
            font-size: 15px;
            line-height: 18px;
            color: $white;
        }
    }
</style>